import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { whiteGlovesInfo } from '@/mocks/benefitsData';

const glovesImage = '/images/generated/benefits-gloves-2026.jpg';

export default function WhiteGlovesSection() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-background-100/60">
      <div className="max-w-[1600px] mx-auto px-8 md:px-12 lg:px-16">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-10 items-start">
          <div className="w-full lg:w-[340px] flex-shrink-0">
            <div className="relative h-[280px] overflow-hidden">
              <img
                src={glovesImage}
                alt={t('benefits.gloves.imgAlt')}
                className="absolute inset-0 w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="flex-1">
            <h2 className="font-heading text-lg md:text-xl text-foreground-900 tracking-[0.06em] mb-2">
              {t('benefits.gloves.title')}
            </h2>
            {String(t('benefits.gloves.titleEn')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">{__s}</p>))}
            <div className="w-10 h-[1px] bg-accent-500/40 mb-5"></div>

            <p className="text-[16px] text-foreground-600 tracking-[0.04em] leading-relaxed mb-5">
              {lang === 'en' ? t('benefits.gloves.lead') : whiteGlovesInfo.lead}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mt-6">
              {([
                { icon: 'ri-calendar-check-line', labelKey: 'benefits.gloves.pt1Label', descKey: 'benefits.gloves.pt1Desc' },
                { icon: 'ri-service-line', labelKey: 'benefits.gloves.pt2Label', descKey: 'benefits.gloves.pt2Desc' },
                { icon: 'ri-shield-star-line', labelKey: 'benefits.gloves.pt3Label', descKey: 'benefits.gloves.pt3Desc' },
              ] as const).map((point, idx) => (
                <div key={idx} className="flex items-start gap-3 bg-background-50 p-4 border border-background-200/60">
                  <div className="w-8 h-8 flex items-center justify-center flex-shrink-0 bg-accent-500/10 rounded-full">
                    <i className={`${point.icon} text-accent-500 text-sm`}></i>
                  </div>
                  <div>
                    {String(t(point.labelKey)).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[14px] text-foreground-800 tracking-[0.04em] font-medium">{__s}</p>))}
                    {String(t(point.descKey)).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-[13px] text-foreground-400 tracking-[0.03em]">{__s}</p>))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
